import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import '../css/sidebar.css';

function Sidebar({ session, handleLogout }) {
    const { t } = useTranslation();

    if (!session.isLoggedIn) return null;

    return (
        <div className="sidebar-container">
            <div className="sidebar-header">
                <img src="/logofull.png" alt="Alshorja Logo" className="sidebar-logo" />
            </div>

            <div className="sidebar-menu">
                <span className="menu-label">{t("sidebar_main")}</span>
                <NavLink to="/users" className="menu-item" activeClassName="active">
                    <i className="fa fa-users"></i> {t("nav_users")}
                </NavLink>
                <NavLink to="/ads" className="menu-item" activeClassName="active">
                    <i className="fa fa-ad"></i> {t("nav_ads_management")}
                </NavLink>
                <NavLink to="/official-products" className="menu-item" activeClassName="active" style={{ color: '#007bff' }}>
                    <i className="fa fa-check-circle"></i> {t("nav_official_products")}
                </NavLink>

                <span className="menu-label">{t("sidebar_analytics")}</span>
                <NavLink to="/stats/categories" className="menu-item" activeClassName="active">
                    <i className="fa fa-chart-pie"></i> {t("nav_statistics")}
                </NavLink>

                <span className="menu-label">{t("sidebar_moderation")}</span>
                <NavLink to="/ad-reports" className="menu-item" activeClassName="active">
                    <i className="fa fa-flag"></i> {t("nav_ad_reports")}
                </NavLink>
                <NavLink to="/user-reports" className="menu-item" activeClassName="active">
                    <i className="fa fa-user-shield"></i> {t("nav_user_reports")}
                </NavLink>
                <NavLink to="/chats" className="menu-item" activeClassName="active">
                    <i className="fa fa-comments"></i> {t("nav_chats")}
                </NavLink>
                <NavLink to="/manage/services" className="menu-item" activeClassName="active">
                    <i className="fa fa-tools"></i> {t("nav_services_management")}
                </NavLink>
                <NavLink to="/manage/wanted" className="menu-item" activeClassName="active">
                    <i className="fa fa-search-dollar"></i> {t("nav_wanted_moderation")}
                </NavLink>

                <span className="menu-label">{t("sidebar_content")}</span>
                <NavLink to="/manage/homepage" className="menu-item" activeClassName="active">
                    <i className="fa fa-home"></i> {t("nav_homepage")}
                </NavLink>

                <span className="menu-label">{t("sidebar_financials")}</span>
                <NavLink to="/invoices" className="menu-item" activeClassName="active">
                    <i className="fa fa-file-invoice-dollar"></i> {t("nav_invoices")}
                </NavLink>

                <span className="menu-label">{t("sidebar_configuration")}</span>
                <NavLink to="/manage/conditions" className="menu-item" activeClassName="active">
                    <i className="fa fa-sliders-h"></i> {t("nav_settings")}
                </NavLink>
            </div>

            <div className="sidebar-footer">
                <button className="logout-btn" onClick={handleLogout}>
                    <i className="fa fa-sign-out-alt"></i> {t("logout")}
                </button>
            </div>
        </div>
    );
}

export default Sidebar;
